/* eslint-disable sonarjs/cognitive-complexity */
import React from 'react';

import { BaSeLoading, BaSeParagraph, BaSeSmall1, BaSeTheme } from '@base/react';
import * as Sebrae from '@sebrae/react-core';

import { useReport } from '../hook/useReport';
import BarWindowJohari from './bar';
import {
  Container,
  ContainerLegenda,
  ContentLegenda,
  GeneralContent,
  GridItem,
  Item,
  Quadrado,
} from './johari-windo-bar-style';

const dataDefault = {
  labels: ['1', '3', '5', '15'],
  datasets: [
    {
      label: '',
      data: [1, 3, 5, 15],
      backgroundColor: [
        'rgba(68, 114, 196, 1)',
        'rgba(238, 125, 48, 1)',
        'rgba(147, 147, 147, 1)',
        'rgba(255, 191, 0, 1)',
      ],
    },
  ],
};

const legendMap = [
  {
    title: 'Não sei dizer',
    color: '#4472C4',
  },
  {
    title: 'Não demonstra',
    color: '#EE7D30',
  },
  {
    title: 'Demonstra ocasionalmente',
    color: '#939393',
  },
  {
    title: 'Demonstra com frequência',
    color: '#FFBF00',
  },
];
function JohariWindowBar() {
  const { getRouteParam } = Sebrae.useSebraeRouter();
  const { getStepData, laoding } = useReport();
  const [response, setResponse] = React.useState(dataDefault);
  const [erro, setErro] = React.useState();

  React.useEffect(() => {
    getStepData({ cpf: getRouteParam('cpf'), step: 'JANELAS_JOHARI_CCE' })
      .then((response) => {
        setResponse(response);
      })
      .catch((error) => {
        setErro(error);
        console.log('deu erro', error);
      });
  }, [getRouteParam, getStepData]);

  if (laoding) {
    return (
      <BaSeLoading
        backgroundColor="#fff"
        description=""
        lightMode="default"
        shadowLevel={0}
        spinnerColor=""
        spinnerSize={24}
        text="Carregando…"
        textColor=""
      />
    );
  }

  if (!response?.showStep) {
    return <> </>;
  }

  const COLOR_TITLE = '#636363';
  return (
    <>
      <BaSeParagraph color={BaSeTheme.colors.gestao.cinza10} isBold>
        JANELA DE JOHARI
      </BaSeParagraph>
      <GeneralContent>
        {erro &&
          'Não foi possíivel carregar os dados dessa sessão do relatório!'}
        <Container>
          <GridItem>
            <Item>
              <BaSeSmall1 color={COLOR_TITLE}>
                {response?.data?.cceOne?.title}
              </BaSeSmall1>
              <div>
                <BarWindowJohari item={response?.data?.cceOne} />
              </div>
            </Item>

            <Item>
              <BaSeSmall1 color={COLOR_TITLE}>
                {response?.data?.cceTwo?.title}
              </BaSeSmall1>
              <div>
                <BarWindowJohari item={response?.data?.cceTwo} />
              </div>
            </Item>
          </GridItem>

          <GridItem>
            <Item>
              <BaSeSmall1 color={COLOR_TITLE}>
                {response?.data?.cceThree?.title}
              </BaSeSmall1>
              <div>
                <BarWindowJohari item={response?.data?.cceThree} />
              </div>
            </Item>

            <Item>
              <BaSeSmall1 color={COLOR_TITLE}>
                {response?.data?.cceFour?.title}
              </BaSeSmall1>
              <div>
                <BarWindowJohari item={response?.data?.cceFour} />
              </div>
            </Item>
          </GridItem>

          <GridItem>
            <Item>
              <BaSeSmall1 color={COLOR_TITLE}>
                {response?.data?.cceFive?.title}
              </BaSeSmall1>
              <div>
                <BarWindowJohari item={response?.data?.cceFive} />
              </div>
            </Item>

            <Item>
              <BaSeSmall1 color={COLOR_TITLE}>
                {response?.data?.cceSix?.title}
              </BaSeSmall1>
              <div>
                <BarWindowJohari item={response?.data?.cceSix} />
              </div>
            </Item>
          </GridItem>

          <GridItem>
            <Item>
              <BaSeSmall1 color={COLOR_TITLE}>
                {response?.data?.cceSeven?.title}
              </BaSeSmall1>
              <div>
                <BarWindowJohari item={response?.data?.cceSeven} />
              </div>
            </Item>

            <Item>
              <BaSeSmall1 color={COLOR_TITLE}>
                {response?.data?.cceEight?.title}
              </BaSeSmall1>
              <div>
                <BarWindowJohari item={response?.data?.cceEight} />
              </div>
            </Item>
          </GridItem>

          <GridItem>
            <Item>
              <BaSeSmall1 color={COLOR_TITLE}>
                {response?.data?.cceNine?.title}
              </BaSeSmall1>
              <div>
                <BarWindowJohari item={response?.data?.cceNine} />
              </div>
            </Item>

            <Item>
              <BaSeSmall1 color={COLOR_TITLE}>
                {response?.data?.cceTen?.title}
              </BaSeSmall1>
              <div>
                <BarWindowJohari item={response?.data?.cceTen} />
              </div>
            </Item>
          </GridItem>
        </Container>
        <div>
          <BaSeSmall1 color={COLOR_TITLE}>Legenda:</BaSeSmall1>
          <ContentLegenda>
            {legendMap.map((legenda) => (
              <ContainerLegenda>
                <Quadrado color={legenda.color} />
                <BaSeSmall1 color={COLOR_TITLE}>{legenda.title}</BaSeSmall1>
              </ContainerLegenda>
            ))}
          </ContentLegenda>
        </div>
      </GeneralContent>
    </>
  );
}

export default JohariWindowBar;
